import React from "react";
import Contactesagenda from "./Contactesagenda";
import "../dashboard_v2.css";

function ContactesPage() {
  return <Contactesagenda />;
}

export default ContactesPage;
